'use strict';

/* eslint no-undef: "off" */
/**
 * cms index app
 */
define('homeApp',['openApp', 'headerWrapper', 'footerWrapper', 'cmsIndexMain', 'searchPanel', 'sideMenu', 'countryChoose', 'GAReport'], function (openApp, headerWrapper, footerWrapper, cmsIndexMain, searchPanel, sideMenu, countryChoose, GAReport) {
  new GAReport().init({
    pageGroup: "HOME"
  });
  return {
    template: '\n      <div class="page-container in-cms-index">\n        <side-menu></side-menu>\n        <country-choose></country-choose>\n        <div class="in-cms-index">\n          <!-- <open-app></open-app> -->\n          <header-wrapper></header-wrapper>\n          <cms-index-main></cms-index-main>\n          <footer-wrapper pageId="home"></footer-wrapper>\n        </div>\n        <search-panel></search-panel>\n      </div>\n    ',
    components: {
      openApp: openApp,
      headerWrapper: headerWrapper,
      footerWrapper: footerWrapper,
      cmsIndexMain: cmsIndexMain,
      searchPanel: searchPanel,
      sideMenu: sideMenu,
      countryChoose: countryChoose
    }
  };
});
